(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["roarcraft-strap-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
if (customElements.get('roarcraft-strap-finder')) return;
function mount(root, config, host) {
const {straps,watches}=config.catalog,strings=config.strings;
let thumbnailObserver,resizeObserver;
const svgNS='http://www.w3.org/2000/svg',preview=root.getElementById('preview'),slots=[];
let keys=Object.keys(straps).filter(key=>config.series==='all'||straps[key].series===config.series),seriesFilter=config.series;if(!keys.length){config.series='all';seriesFilter='all';keys=Object.keys(straps);}
if(!keys.length){root.querySelector('.sf-main').textContent=strings.no_straps;return;}
root.querySelectorAll('[data-series]').forEach(button=>{const count=Object.values(straps).filter(strap=>button.dataset.series==='all'||strap.series===button.dataset.series).length;button.hidden=count===0;button.querySelector('span').textContent=count;});
let watchKey=watches[config.watch]?config.watch:'longines',strapKey=keys[0],position=0,resetTimer;
const modulo=(n,m)=>((n%m)+m)%m;
function svgElement(tag,attributes){const e=document.createElementNS(svgNS,tag);for(const [key,value] of Object.entries(attributes))e.setAttribute(key,value);return e}
function rebuildSlots(){
 slots.length=0;root.getElementById('strap-track').replaceChildren();root.querySelectorAll('[id^="slot-"]').forEach(e=>e.remove());
 for(let i=-keys.length;i<keys.length*2;i++){
 const key=keys[modulo(i,keys.length)],group=svgElement('g',{'class':'strap-slot','data-slot':i});
 const suffix='slot-'+(i+keys.length),upperRect=svgElement('rect',{x:-5000,y:-1000,width:10000,height:1500}),lowerRect=svgElement('rect',{x:-5000,y:500,width:10000,height:1500});
 const upperClip=svgElement('clipPath',{id:suffix+'-upper'}),lowerClip=svgElement('clipPath',{id:suffix+'-lower'});upperClip.append(upperRect);lowerClip.append(lowerRect);root.querySelector('#watch-preview defs').append(upperClip,lowerClip);
 const top=svgElement('image',{'clip-path':'url(#'+suffix+'-upper)','preserveAspectRatio':'none'}),bottom=svgElement('image',{'clip-path':'url(#'+suffix+'-lower)','preserveAspectRatio':'none'});
 group.append(top,bottom);root.getElementById('strap-track').append(group);slots.push({index:i,key,group,top,bottom,upperRect,lowerRect});
}
}
function placePiece(image,src,sx,sy,center,anchor,target){if(image.getAttribute('href')!==src)image.setAttribute('href',src);const strap=straps[image.dataset.strap];image.setAttribute('width',(strap?.imageWidth||1024)*sx);image.setAttribute('height',(strap?.imageHeight||1536)*sy);image.setAttribute('x',500-center*sx);image.setAttribute('y',target-anchor*sy)}
function renderWatch(){
 const watch=watches[watchKey],unit=watch.strapWidth/160;

 root.querySelector('#upper-clip rect').setAttribute('height',watch.upper+20);root.querySelector('#lower-clip rect').setAttribute('y',watch.lower-20);root.querySelector('#lower-clip rect').setAttribute('height',1020-watch.lower);
 const head=root.getElementById('watch-head');if(head.getAttribute('href')!==watch.src)head.setAttribute('href',watch.src);for(const key of ['x','y'])head.setAttribute(key,watch[key]);head.setAttribute('width',watch.width||watch.size);head.setAttribute('height',watch.height||watch.size);

 root.querySelectorAll('[data-watch]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.watch===watchKey)));
}
function renderSelection(animate=true){
 if(!animate)preview.classList.add('no-motion');
 const watch=watches[watchKey],unit=watch.strapWidth/160,halfGap=2.5/root.getElementById('watch-preview').getScreenCTM().a;
 slots.forEach(slot=>{const distance=Math.abs(slot.index-position),radius=Math.ceil(preview.clientWidth/(root.getElementById('watch-preview').getScreenCTM().a*645)/2)+1;const visible=distance<=radius;slot.group.style.display=visible?'':'none';if(!visible){slot.top.removeAttribute('href');slot.bottom.removeAttribute('href');return;}slot.top.dataset.strap=slot.key;slot.bottom.dataset.strap=slot.key;const selected=slot.index===position,strap=straps[slot.key],upper=selected?watch.upper:500-halfGap,lower=selected?watch.lower:500+halfGap;
 placePiece(slot.top,strap.src,watch.strapWidth/strap.topWidth,unit*550/strap.topLength,strap.topCenter,strap.upper,upper);placePiece(slot.bottom,strap.src,watch.strapWidth/strap.bottomWidth,unit*800/strap.bottomLength,strap.bottomCenter,strap.lower,lower);
 slot.upperRect.setAttribute('height',selected?watch.upper+1020:1500-halfGap);slot.lowerRect.setAttribute('y',selected?watch.lower-20:500+halfGap);slot.lowerRect.setAttribute('height',selected?2020-watch.lower:1500-halfGap);
 slot.group.style.transform='translateX('+((slot.index-position)*645)+'px)';slot.group.style.opacity=selected?'1':'.32'});
 root.getElementById('preview-title').textContent=strings.preview_title.replace('{watch}',watches[watchKey].name).replace('{strap}',straps[strapKey].name);
 root.getElementById('product-name').textContent=straps[strapKey].fullName;root.getElementById('counter').textContent=(keys.indexOf(strapKey)+1)+' / '+keys.length;root.getElementById('product-link').href=straps[strapKey].url;
 root.querySelectorAll('[data-strap]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.strap===strapKey)));
 const seriesRow=root.querySelector('.series-filters'),activeSeries=seriesRow.querySelector('[aria-pressed="true"]');if(activeSeries){const a=seriesRow.getBoundingClientRect(),b=activeSeries.getBoundingClientRect();seriesRow.scrollTo({left:seriesRow.scrollLeft+b.left-a.left-(a.width-b.width)/2,behavior:'instant'})}
 const choices=root.getElementById('strap-choices'),selected=choices.querySelector('[aria-pressed="true"]');if(selected){const a=choices.getBoundingClientRect(),b=selected.getBoundingClientRect();choices.scrollTo({left:choices.scrollLeft+b.left-a.left-(a.width-b.width)/2,behavior:animate?'smooth':'instant'})}
 if(!animate){preview.getBoundingClientRect();requestAnimationFrame(()=>preview.classList.remove('no-motion'))}
}
function normalizePosition(){const normalized=modulo(position,keys.length);if(position!==normalized){position=normalized;renderSelection(false)}}
function moveTo(next){clearTimeout(resetTimer);const delta=next-position;if(next< -keys.length+3||next>keys.length*2-4){normalizePosition();next=position+delta}position=next;strapKey=keys[modulo(position,keys.length)];renderSelection();resetTimer=setTimeout(normalizePosition,460)}
function selectStrap(key){const target=keys.indexOf(key);let delta=modulo(target-modulo(position,keys.length),keys.length);if(delta>keys.length/2)delta-=keys.length;moveTo(position+delta)}
function stepStrap(direction){moveTo(position+direction)}
function selectWatch(key){watchKey=key;renderWatch();renderSelection(false)}
root.getElementById('previous-strap').addEventListener('click',()=>stepStrap(-1));root.getElementById('next-strap').addEventListener('click',()=>stepStrap(1));
root.querySelectorAll('[data-watch]').forEach(button=>button.addEventListener('click',()=>selectWatch(button.dataset.watch)));

function buildChoices(){
 const container=root.getElementById('strap-choices');container.replaceChildren();
 keys.forEach(key=>{const strap=straps[key],button=document.createElement('button'),dot=document.createElement('span');button.type='button';button.className='choice';button.dataset.strap=key;button.setAttribute('aria-pressed',String(key===strapKey));dot.className='swatch';dot.style.setProperty('--color',strap.color||({brown:'#814334',black:'#242424',grey:'#79776f',blue:'#253956'})[key]);button.append(dot,document.createTextNode(strap.name));button.addEventListener('click',()=>selectStrap(key));container.append(button)});
 container.scrollLeft=0;
}
function selectSeries(series){clearTimeout(resetTimer);seriesFilter=series;keys=Object.keys(straps).filter(key=>series==='all'||straps[key].series===series);if(!keys.includes(strapKey))strapKey=keys[0];position=keys.indexOf(strapKey);root.querySelectorAll('[data-series]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.series===series)));buildChoices();rebuildSlots();renderWatch();renderSelection(false)}
root.querySelectorAll('[data-series]').forEach(button=>button.addEventListener('click',()=>selectSeries(button.dataset.series)));


function buildWatchThumbnails(){
 const row=root.querySelector('.watch-choices');
 const observer=thumbnailObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){const img=entry.target;img.src=img.dataset.src;observer.unobserve(img)}})},{root:row,rootMargin:'0px 100px',threshold:0}):null;
 root.querySelectorAll('[data-watch]').forEach(button=>{
  const watch=watches[button.dataset.watch],thumb=document.createElement('img');thumb.className='watch-thumb';thumb.width=58;thumb.height=58;thumb.alt='';thumb.setAttribute('aria-hidden','true');thumb.decoding='async';thumb.loading='lazy';thumb.dataset.src=watch.thumb;button.prepend(thumb);
  if(observer)observer.observe(thumb);else thumb.src=watch.thumb;
  const warm=()=>{const image=new Image();image.decoding='async';image.src=watch.src};button.addEventListener('pointerenter',warm,{once:true});button.addEventListener('focus',warm,{once:true});
 });
}

let pointerStart=null,ignoreClick=false;
preview.addEventListener('pointerdown',event=>{if(event.target.closest('button'))return;pointerStart={x:event.clientX,y:event.clientY}});
preview.addEventListener('pointerup',event=>{if(!pointerStart)return;const dx=event.clientX-pointerStart.x,dy=event.clientY-pointerStart.y;pointerStart=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){ignoreClick=true;stepStrap(dx<0?1:-1);setTimeout(()=>ignoreClick=false,0)}});
preview.addEventListener('click',event=>{
 if(ignoreClick||event.target.closest('button'))return;
 const bounds=preview.getBoundingClientRect(),offset=event.clientX-bounds.left-bounds.width/2;
 const centerWidth=(watches[watchKey].strapWidth/2+40)*root.getElementById('watch-preview').getScreenCTM().a;
 if(Math.abs(offset)>centerWidth)stepStrap(offset<0?-1:1);
});
preview.addEventListener('pointercancel',()=>pointerStart=null);preview.addEventListener('click',event=>{if(ignoreClick){event.preventDefault();event.stopPropagation()}},true);
preview.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();stepStrap(event.key==='ArrowLeft'?-1:1)}});
function resizeScene(){
 const scene=root.getElementById('watch-preview');
 const scale=preview.clientWidth<=680?preview.clientWidth/1600:(572/1000)*.648;
 const width=preview.clientWidth/scale,height=preview.clientHeight/scale;
 scene.setAttribute('viewBox',(500-width/2)+' '+(500-height/2)+' '+width+' '+height);
}
buildWatchThumbnails();
host.previewState=()=>({watch:watchKey,strap:strapKey,series:seriesFilter,count:keys.length});resizeObserver=new ResizeObserver(()=>{if(preview.clientWidth>0){resizeScene();renderSelection(false)}});resizeObserver.observe(preview);resizeScene();buildChoices();rebuildSlots();renderWatch();selectSeries(seriesFilter);

return ()=>{clearTimeout(resetTimer);thumbnailObserver?.disconnect();resizeObserver?.disconnect();delete host.previewState};
}
class RoarcraftStrapFinder extends HTMLElement {
 connectedCallback() {
  this.version=(this.version||0)+1;
  const version=this.version;
  const root=this.shadowRoot||this.attachShadow({mode:'open'});
  const template=this.querySelector('template');
  if(!template) return;
  root.replaceChildren(template.content.cloneNode(true));
  const config=JSON.parse(this.querySelector('[data-config]').textContent);
  const start=()=>{if(!this.isConnected||this.version!==version||this.cleanup)return;if(!this.clientWidth){if(!this.pendingResize){this.pendingResize=new ResizeObserver(start);this.pendingResize.observe(this)}return}this.pendingResize?.disconnect();this.pendingResize=null;this.cleanup=mount(root,config,this)};
  root.querySelector('link').addEventListener('load',start,{once:true});
  root.querySelector('link').addEventListener('error',()=>{root.append(document.createTextNode(config.strings.no_script))},{once:true});
 }
 disconnectedCallback() {this.version++;this.pendingResize?.disconnect();this.pendingResize=null;this.cleanup?.();this.cleanup=null;}
}
customElements.define('roarcraft-strap-finder',RoarcraftStrapFinder);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
